import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5ea0b7ac&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea0b7ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ea0b7ac')) {
      api.createRecord('5ea0b7ac', component.options)
    } else {
      api.reload('5ea0b7ac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5ea0b7ac&scoped=true", function () {
      api.rerender('5ea0b7ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CCoupon/index.vue"
export default component.exports